import apiClient from './apiClient';

/*
 * Briefing list — symbols included in the daily briefing but NOT on the
 * watchlist (Mag7, macro/dollar, sector bellwethers). The briefing unions
 * watchlist + briefing list; the watchlist alone drives the active views.
 */

export const getBriefingList = async () => {
  const response = await apiClient.get('/briefing-list');
  return response.data?.briefingList || [];
};

export const addToBriefingList = async (symbol) => {
  const response = await apiClient.post('/briefing-list', { symbol });
  return response.data;
};

export const removeFromBriefingList = async (symbol) => {
  // Pass via query param so pair symbols (BTC/USD) don't break the path route.
  const response = await apiClient.delete('/briefing-list', { params: { symbol } });
  return response.data;
};

export default { getBriefingList, addToBriefingList, removeFromBriefingList };
